<div class="flex-gap-5">
  <ng-template #orderPreviewTemplate>
    <div class="container-fluid popover-max-width" data-cy="order-preview-popover">
      <div class="row">
        <div class="col popover-table">
          @if (orderDetails?.reservationNumber > 0 || orderDetails?.billNumber > 0) {
            <div class="row">
              <div class="col">
                <div class="text-nowrap card-title">
                  {{
                    orderDetails.reservationNumber > 0
                      ? ('order' | translate) + ' ' + orderDetails.reservationNumber
                      : ''
                  }}
                  {{ orderDetails.reservationNumber > 0 && orderDetails.billNumber > 0 ? ' - ' : '' }}
                  {{
                    orderDetails.billNumber > 0 && !order?.relatedParent?.id
                      ? ('bill' | translate) + ' ' + orderDetails.billNumber
                      : ''
                  }}
                </div>
              </div>
            </div>
          }
          <table class="table">
            <tbody class="images" [photoGalleryGroup]="{ index: 1 }">
              @for (it of orderDetails?.items; track it) {
                <tr>
                  <td class="ps-0 no-hover">
                    <div class="flex-gap-10 align-items-center">
                      @if (it.type === 'product' && it.product && it.product.id > 0) {
                        <div
                          [photoGallery]="it?.product?.mainImage?.url"
                          [photoGalleryCaption]="
                            it.product
                              ? it.product.fullName +
                                '<br>' +
                                (it.product.code ? ('product.code' | translate) + it.product.code : '') +
                                '<br>' +
                                (it.product.ean ? ' EAN: ' + it.product.ean : '')
                              : ''
                          "
                        >
                          <div class="images-item">
                            @if (!!it.product.mainImage?.url?.length && !!it.product.mainImage?.thumbnails?.length) {
                              <img
                                class="images-item-image"
                                [src]="getThumbUrl(it.product.mainImage)"
                                [alt]="it.product.fullName"
                              />
                            }
                            @if (!it.product.mainImage?.url?.length || !it.product.mainImage?.thumbnails?.length) {
                              <img
                                class="images-item-image"
                                [src]="'assets/img/no-image.png'"
                                [alt]="it.product.fullName"
                              />
                            }
                          </div>
                        </div>
                      }
                      <div>
                        @if (it.type === 'product' && it.product && it.product.id > 0) {
                          <a class="link-bold" [routerLink]="['/product', it.product.id]" data-cy="orderItem-link">
                            @if (it.name) {
                              <span>{{ it.name }}</span>
                            }
                          </a>
                        }
                        @if (!(it.type === 'product' && it.product && it.product.id > 0)) {
                          <span>
                            @if (it.name) {
                              <span>{{ it.name }}</span>
                            }
                          </span>
                        }
                        <div class="product-details flex-gap-5 flex-wrap">
                          @if (it.code) {
                            <div>{{ 'product.code' | translate }}: {{ it.code }}</div>
                          }
                          @if (it.ean) {
                            <div>{{ 'product.ean' | translate }}: {{ it.ean }}</div>
                          }
                          @if (it.clearanceItems && it.clearanceItems.length && it.clearanceItems[0].expirationDate) {
                            <div>
                              {{ 'product.expirationDate' | translate }}: {{ it.clearanceItems[0].expirationDate }}
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-end text-nowrap pe-0 no-hover">
                    <div style="display: inline-flex">
                      <div class="unavailable-items" title="{{ 'quantityStock' | translate }}">
                        @if (it.quantityUnavailable > 0) {
                          <span
                            title="{{ 'quantityUnavailable' | translate }}"
                            class="badge bg-danger"
                            id="unavailable-pieces"
                          >
                            {{ it.quantityUnavailable }}
                          </span>
                        }
                      </div>
                      <div class="table-status" title="{{ 'numberOfItems' | translate }}">
                        {{ it.quantity }}
                      </div>
                    </div>
                    <div class="product-price">
                      {{ it.price | formatPrice: orderDetails.currency }}
                    </div>
                  </td>
                </tr>
              }
              <tr>
                <td class="table-sum ps-0 no-hover">
                  {{ 'price.total' | translate }}
                </td>
                <td class="text-nowrap pe-0 text-end table-sum no-hover">
                  {{ orderDetails?.priceAll | formatPrice: orderDetails?.currency }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col popover-info max-width-50percent">
          <div class="row">
            <div class="col-12 ps-0 pe-0 d-flex justify-content-end">
              <btn
                [label]="'close'"
                [title]="'close' | translate"
                [icon]="'far-ban'"
                [classes]="['btn-third', 'btn-sm', 'me-2']"
                (click)="closePopover()"
                [dataCyAttribute]="'close-popover'"
              ></btn>
              <a
                class="btn-first btn-sm d-flex align-items-center"
                [routerLink]="['/order', order.id]"
                data-cy="open-order-from-popover"
              >
                <span class="flex-gap-5 align-items-center"><i class="far fa-pen"></i>{{ 'open' | translate }}</span>
              </a>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1O ps-0 pe-0">
              <div class="order-card">
                <div class="table-responsive">
                  <table class="w-100">
                    <tbody>
                      @if (orderDetails?.processStatus) {
                        <tr>
                          <td class="td-left no-hover">{{ 'processStatus' | translate }}:</td>
                          <td class="text-end no-hover pe-1">
                            <span
                              class="inline-flex-gap-5 align-items-center"
                              [ngClass]="'process-status-' + orderDetails.processStatus.id"
                            >
                              <i
                                [ngClass]="
                                  orderDetails.processStatus.id === 'recieved'
                                    ? 'far fa-cart-arrow-down'
                                    : orderDetails.processStatus.id === 'picking'
                                      ? 'far fa-scanner'
                                      : orderDetails.processStatus.id === 'packing'
                                        ? 'far fa-box-full'
                                        : orderDetails.processStatus.id === 'packed'
                                          ? 'far fa-box-check'
                                          : orderDetails.processStatus.id === 'dispatched'
                                            ? 'far fa-shipping-fast'
                                            : orderDetails.processStatus.id === 'delivered'
                                              ? 'far fa-check-circle'
                                              : orderDetails.processStatus.id === 'returned'
                                                ? 'far fa-shipping-timed'
                                                : orderDetails.processStatus.id === 'picking_error'
                                                  ? 'far fa-exclamation-triangle'
                                                  : orderDetails.processStatus.id === 'cancelled'
                                                    ? 'far fa-ban'
                                                    : ''
                                "
                              >
                              </i>
                              <span data-cy="orderPreview-processStatus">{{ orderDetails.processStatus?.name }}</span>
                            </span>
                          </td>
                        </tr>
                      }
                      @if (orderDetails?.status) {
                        <tr>
                          <td class="td-left no-hover">{{ 'order.status' | translate }}:</td>
                          <td class="td-right no-hover" data-cy="orderPreview-status">
                            {{ 'order-' + orderDetails.status.id | translate }}
                          </td>
                        </tr>
                      }
                      @if (orderDetails?.externalReference) {
                        <tr>
                          <td class="td-left no-hover">{{ 'externalReference' | translate }}:</td>
                          <td class="td-right no-hover text-wrap" data-cy="orderPreview-externalReference">
                            {{ orderDetails.externalReference }}
                          </td>
                        </tr>
                      }
                      @if (orderDetails?.carrier) {
                        <tr>
                          <td class="td-left no-hover">{{ 'shipping' | translate }}:</td>
                          <td class="td-right no-hover" data-cy="orderPreview-carrier">
                            {{ orderDetails.carrier.name ? orderDetails.carrier.name : '' }}
                          </td>
                        </tr>
                      }
                      @if (orderDetails?.paymentItems.length) {
                        <tr>
                          <td class="td-left no-hover">{{ 'payment.form' | translate }}:</td>
                          <td class="td-right no-hover">
                            @for (paymentItem of orderDetails.paymentItems; track paymentItem) {
                              <span>
                                @if (paymentItem.payment?.type?.name) {
                                  <span class="ps-2" data-cy="orderPreview-payment">
                                    {{ paymentItem.payment.type.name }}</span
                                  >
                                }
                              </span>
                            }
                          </td>
                        </tr>
                      }
                      @for (paymentItem of orderDetails?.paymentItems; track paymentItem) {
                        @if (paymentItem.isPaid && paymentItem.datePaid) {
                          <tr>
                            <td class="td-left no-hover">{{ 'datePaid' | translate }}:</td>
                            <td class="td-right text-nowrap no-hover" data-cy="orderPreview-datePaid">
                              {{ paymentItem.datePaid | fmtDate: 'dd.MM.yyyy HH:mm' }}
                            </td>
                          </tr>
                        }
                      }
                      @if (orderDetails?.checkout?.name) {
                        <tr>
                          <td class="td-left no-hover">{{ 'cashdesk' | translate }}:</td>
                          <td class="td-right no-hover" data-cy="orderPreview-checkout">
                            {{ orderDetails.checkout.name }}
                          </td>
                        </tr>
                      }
                      @if (orderDetails?.dateCreated) {
                        <tr>
                          <td class="td-left no-hover">{{ 'orders.stock.created' | translate }}:</td>
                          <td class="td-right text-nowrap no-hover" data-cy="orderPreview-dateCreated">
                            {{ orderDetails.dateCreated | fmtDate: 'dd.MM.yyyy' }}
                            {{ orderDetails.dateCreated | fmtDate: 'HH:mm' }}
                          </td>
                        </tr>
                      }
                      @if (orderDetails?.createdBy?.lastName) {
                        <tr>
                          <td class="td-left no-hover">{{ 'createdBy' | translate }}:</td>
                          <td class="td-right no-hover" data-cy="orderPreview-createdBy">
                            {{ orderDetails.createdBy.lastName }}
                          </td>
                        </tr>
                      }
                      @if (orderDetails?.externalId) {
                        <tr>
                          <td class="td-left no-hover">{{ 'externalId' | translate }}:</td>
                          <td class="td-right no-hover">
                            {{ orderDetails.externalId }}
                          </td>
                        </tr>
                      }
                      @if (orderDetails?.priority) {
                        <tr>
                          <td class="td-left no-hover">{{ 'priority' | translate }}:</td>
                          <td class="td-right no-hover" data-cy="orderPreview-priority">
                            {{ orderDetails.priority }}
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          @if (orderDetails?.note?.length) {
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1O shipping-card">
                <div class="card-subheading text-nowrap">
                  {{ 'note' | translate }}
                </div>
                <div data-cy="orderPreview-note">
                  {{ orderDetails.note }}
                </div>
              </div>
            </div>
          }
          @if (orderDetails?.privateNote?.length) {
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1O shipping-card">
                <div class="card-subheading text-nowrap">
                  {{ 'note.private' | translate }}
                </div>
                <div data-cy="orderPreview-privateNote">
                  {{ orderDetails.privateNote }}
                </div>
              </div>
            </div>
          }
          @if (orderDetails?.invoiceAddress && orderDetails?.shippingAddress && !areAddressesSame) {
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1O shipping-card">
                <div class="row">
                  <div class="col d-flex justify-content-between">
                    <div class="avatar-wrapper">
                      <div>
                        <div class="circle">
                          <span class="initials">
                            {{
                              orderDetails.invoiceAddress.firstName?.length
                                ? orderDetails.invoiceAddress.firstName[0]
                                : ''
                            }}
                            {{
                              orderDetails.invoiceAddress.lastName?.length
                                ? orderDetails.invoiceAddress.lastName[0]
                                : ''
                            }}
                          </span>
                        </div>
                      </div>
                      <div>
                        <div>{{ orderDetails.invoiceAddress.firstName }}</div>
                        <div class="last-name">{{ orderDetails.invoiceAddress.lastName }}</div>
                      </div>
                    </div>
                    <div class="shipping-card-details">
                      {{ 'address.invoice' | translate }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    @if (orderDetails.invoiceAddress.email) {
                      <div class="row">
                        <div class="col shipping-card-details">
                          <span><i class="far fa-envelope"></i> {{ orderDetails.invoiceAddress.email }}</span>
                        </div>
                      </div>
                    }
                    @if (orderDetails.invoiceAddress.phone) {
                      <div class="row">
                        <div class="col shipping-card-details">
                          <span><i class="far fa-phone-alt"></i> {{ orderDetails.invoiceAddress.phone }}</span>
                        </div>
                      </div>
                    }
                    @if (
                      orderDetails.invoiceAddress.street &&
                      orderDetails.invoiceAddress.zip &&
                      orderDetails.invoiceAddress.city
                    ) {
                      <div class="row">
                        <div class="col shipping-card-details">
                          <span>
                            <i class="far fa-map-marker"></i>
                            {{ orderDetails.invoiceAddress.street }}, {{ orderDetails.invoiceAddress.zip }},
                            {{ orderDetails.invoiceAddress.city }}
                          </span>
                        </div>
                      </div>
                    }
                    <div class="row">
                      <div class="col shipping-card-details">
                        @if (orderDetails?.invoiceAddress?.ic) {
                          <span>
                            {{ 'company.ic' | translate }}
                            {{ orderDetails?.invoiceAddress?.ic }}
                          </span>
                        }
                        @if (orderDetails?.invoiceAddress?.dic) {
                          <span>
                            {{ 'company.dic' | translate }}
                            {{ orderDetails?.invoiceAddress?.dic }}
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (orderDetails?.shippingAddress) {
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1O shipping-card">
                <div class="row">
                  <div
                    class="col"
                    [ngClass]="
                      orderDetails?.invoiceAddress && !areAddressesSame ? 'd-flex justify-content-between' : ''
                    "
                  >
                    <div class="avatar-wrapper">
                      <div>
                        <div class="circle">
                          <span class="initials">
                            {{
                              orderDetails.shippingAddress.firstName?.length
                                ? orderDetails.shippingAddress.firstName[0]
                                : ''
                            }}
                            {{
                              orderDetails.shippingAddress.lastName?.length
                                ? orderDetails.shippingAddress.lastName[0]
                                : ''
                            }}
                          </span>
                        </div>
                      </div>
                      <div>
                        <div>{{ orderDetails.shippingAddress.firstName }}</div>
                        <div class="last-name">{{ orderDetails.shippingAddress.lastName }}</div>
                      </div>
                    </div>
                    @if (orderDetails.invoiceAddress && !areAddressesSame) {
                      <div class="shipping-card-details">
                        {{ 'address.shipping' | translate }}
                      </div>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    @if (orderDetails.shippingAddress.email) {
                      <div class="row">
                        <div class="col shipping-card-details">
                          <span><i class="far fa-envelope"></i> {{ orderDetails.shippingAddress.email }}</span>
                        </div>
                      </div>
                    }
                    @if (orderDetails.shippingAddress.phone) {
                      <div class="row">
                        <div class="col shipping-card-details">
                          <span><i class="far fa-phone-alt"></i> {{ orderDetails.shippingAddress.phone }}</span>
                        </div>
                      </div>
                    }
                    @if (
                      orderDetails.shippingAddress.street &&
                      orderDetails.shippingAddress.zip &&
                      orderDetails.shippingAddress.city
                    ) {
                      <div class="row">
                        <div class="col shipping-card-details">
                          <span>
                            <i class="far fa-map-marker"></i>
                            {{ orderDetails.shippingAddress.street }}, {{ orderDetails.shippingAddress.zip }},
                            {{ orderDetails.shippingAddress.city }}
                          </span>
                        </div>
                      </div>
                    }
                    <div class="row">
                      <div class="col shipping-card-details">
                        @if (orderDetails.shippingAddress.ic) {
                          <span>{{ 'company.ic' | translate }} {{ orderDetails.shippingAddress.ic }}</span>
                        }
                        @if (orderDetails.shippingAddress.dic) {
                          <span> | {{ 'company.dic' | translate }} {{ orderDetails.shippingAddress.dic }}</span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </ng-template>

  <button
    type="button"
    class="btn border-0 button-preview p-0 btn-outline-primary"
    [ngClass]="isOnProductMovePackPage ? 'btn-outline-primary-white-background' : ''"
    [popover]="isOpen ? orderPreviewTemplate : ''"
    [placement]="'right top'"
    container="div.wrapper"
    [isOpen]="isOpen"
    [adaptivePosition]="!isOnProductMovePackPage"
    #pop="bs-popover"
    [title]="'order.preview' | translate"
    (click)="fetchOrderDetail(order.id)"
    triggers="'focus'"
    [attr.data-cy]="'order-preview'"
  >
    <div class="icons-order-preview">
      @if (!isFetching) {
        <i class="far fa-eye text-center eye-icon"> </i>
      }
      @if (order?.note?.length && !isFetching) {
        <i class="far fa-comment-lines note-icon" [title]="'note' | translate"> </i>
      }
      @if (order?.privateNote?.length && !isFetching) {
        <i class="fas fa-comment-lines private-note-icon" [title]="'note.private' | translate"> </i>
      }
    </div>
    @if (isFetching) {
      <div class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    }
  </button>
  @if (!isOnOrdersPage) {
    <span class="align-self-center">
      <a class="link" [routerLink]="['/order', order.id]">
        {{ order?.reservationNumber ? order.reservationNumber : order?.billNumber }}
      </a>
    </span>
  }
</div>
